// Tiny image helper - proxies external images through wsrv.nl, a free
// global CDN that:
//   1. Serves a redundant cached copy when the origin is slow/unreachable
//   2. Resizes on-the-fly so retina and mobile both get the right pixels
//   3. Returns WebP by default with safe fallback for older browsers
//
// Usage:
//   img(srcUrl, { w: 900 })  -> "https://wsrv.nl/?url=...&w=900&output=webp&q=82"
//   img(srcUrl)              -> WebP with default quality, no resize
//
// Leave srcUrl untouched if it is already a wsrv.nl URL, or a relative path,
// or already a data: URL. We only proxy external HTTP(S) origins.

const WSRV = "https://wsrv.nl/";

export function img(src, opts = {}) {
  if (!src || typeof src !== "string") return src;
  if (src.startsWith("data:") || src.startsWith("blob:")) return src;
  if (src.startsWith("/")) return src;
  if (src.includes("wsrv.nl/")) return src;

  // wsrv.nl expects the URL WITHOUT the leading "https://" - just the host + path.
  let bare = src.replace(/^https?:\/\//, "");

  const params = new URLSearchParams();
  params.set("url", bare);
  if (opts.w) params.set("w", String(opts.w));
  if (opts.h) params.set("h", String(opts.h));
  if (opts.fit) params.set("fit", opts.fit);
  params.set("output", opts.output || "webp");
  params.set("q", String(opts.q || 82));
  // wsrv expects raw URL (it handles percent-encoded inputs fine).

  return `${WSRV}?${params.toString()}`;
}

// Build a width-based srcset for retina + responsive selection.
export function imgSrcSet(src, widths = [400, 600, 900, 1200]) {
  if (!src || src.startsWith("data:") || src.startsWith("/")) return undefined;
  return widths.map((w) => `${img(src, { w })} ${w}w`).join(", ");
}
